const utils = require("../utils");

/**
 * Gets autocomplete implementation depending on library loaded (Google|Baidu).
 * @private
 * @returns {BaiduAutocompleteService|google.maps.places.AutocompleteService|null}
 */
function getAutocompleteService() {
    if (google.maps.places !== undefined) {
        return new google.maps.places.AutocompleteService();
    }
    return null;
}

module.exports = {
    getAutocompleteService,
};
